import { safeGet } from '../../../../core/utils/safe-get.js';
import type { AxisIdToScales } from '../../../context/XYChartScales.context.js';
import type { XYChartAxisInternal } from '../../../types/xy-chart-internals.js';

const LEFT = 0;
const RIGHT = 1;

export function getVisibleArrows(
  XAxes: XYChartAxisInternal[],
  isInfinite: boolean,
  scales: AxisIdToScales,
): [boolean, boolean] {
  if (isInfinite) {
    return [true, true];
  }

  const leftArrow = XAxes.some((axis) => {
    const { currentScale, initialScale } = safeGet(scales, axis.id);
    return (
      currentScale.domain()[LEFT].valueOf() !==
      initialScale.domain()[LEFT].valueOf()
    );
  });

  const rightArrow = XAxes.some((axis) => {
    const { currentScale, initialScale } = safeGet(scales, axis.id);
    return (
      currentScale.domain()[RIGHT].valueOf() !==
      initialScale.domain()[RIGHT].valueOf()
    );
  });

  return [leftArrow, rightArrow];
}
